angular.module('gym.calendar').controller('SetMeetingDetailsCtrl', ["$scope", "$rootScope", "$modalInstance", "$http", "event", function($scope, $rootScope, $modalInstance, $http, event) {
  var gym;
  gym = $rootScope.gym;
  $scope.data = {
    meeting_url: event.meeting_url,
    meeting_instructions: event.meeting_instructions
  };
  $scope.save = function() {
    var url;
    $scope.isLoading = true;
    $scope.errors = {};
    url = `/gyms/${gym.id}/calendar/events/${event.id}/update_meeting_details`;
    return $http.put(url, {
      event: $scope.data
    }).then(function() {
      return $modalInstance.close($scope.data);
    }, function(response) {
      $scope.errors = response.data.errors;
      return $scope.isLoading = false;
    });
  };
  return $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
}]);
